"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Validators = require("./Validators");

var _Validators2 = _interopRequireDefault(_Validators);

var _Utils = require("./Utils");

var _Utils2 = _interopRequireDefault(_Utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RULE_SEPARATOR = '|';
var PARAMETER_SEPARATOR = ':';
var ARGUMENT_SEPARATOR = ',';

var Rule = function () {
    function Rule() {
        _classCallCheck(this, Rule);
    }

    _createClass(Rule, null, [{
        key: "parse",

        /**
         * Parse the rule string (e.g. required|max:255|in:1,2,3)
         * and return the rules.
         *
         * @param {String} rulesString
         * @param {String} name
         * @returns {Object}
         */
        value: function parse(rulesString, name) {
            var rules = {};

            // Construct all rules, with their args.
            rulesString.split(RULE_SEPARATOR).map(function (ruleString) {
                var args = ruleString.split(PARAMETER_SEPARATOR).map(function (arg) {
                    return arg.split(ARGUMENT_SEPARATOR);
                });

                // Add rule, with args, to rules object.
                rules[args[0]] = args.slice(1, args.length);
                rules[args[0]].unshift(name);
            });

            return rules;
        }

        /**
         * Test the given input against the given rule.
         *
         * @param {String} rule
         * @param {Array} args
         * @param {String} input
         * @param {String=} message
         * @returns {Object}
         */

    }, {
        key: "test",
        value: function test(rule, args, input, message) {
            if (!_Validators2.default.hasOwnProperty(rule)) {
                console.error("Rule " + rule + " does not exist");

                return {
                    passed: false,
                    error: 'Failed validation'
                };
            }

            // Don't clean objects.
            input = (typeof input === "undefined" ? "undefined" : _typeof(input)) === 'object' ? input : _Utils2.default.cleanInput(input);

            // Add input to beginning of args array.
            args.unshift(input);

            // Add message to end of array.
            args.push(message);

            // Format name
            args[1] = _Utils2.default.cleanName(args[1]);

            return _Validators2.default[rule].apply(_Validators2.default, _toConsumableArray(args));
        }

        /**
         * Add the given rule to the Validators object, if it
         * doesn't already exist.
         *
         * @param {String} rule
         * @param {Function} validator
         */

    }, {
        key: "add",
        value: function add(rule, validator) {
            _Validators2.default[rule] = validator;
        }
    }]);

    return Rule;
}();

exports.default = Rule;